export const VNTABS_SET_MODAL_ACTIVE = 'VNTABS_SET_MODAL_ACTIVE'
export const VNTABS_SET_TAB_NAME_REQUIRED = 'VNTABS_SET_TAB_NAME_REQUIRED'
